module.exports = __webpack_public_path__ + "static/img/artistic-b.8ddf87d0.png";